<template>
    <div v-if="activeClient" class="pa-5 compact-form">
        <div v-for="(item, index) in activeClient.contacts" :key="item.id">
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Name" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.name"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        outlined
                        @input="updateContactField($event, 'name', index)"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Phone" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.phone"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        outlined
                        @input="updateContactField($event, 'phone', index)"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Position" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.position"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        outlined
                        @input="updateContactField($event, 'position', index)"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Email" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.email"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        outlined
                        @input="updateContactField($event, 'email', index)"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col class="mt-2 row-title" cols="3">{{ "Comment" | t }}</v-col>
                <v-col cols="6">
                    <v-text-field
                        :value="item.comment"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        outlined
                        @input="updateContactField($event, 'comment', index)"
                    />
                </v-col>
            </v-row>
            <v-row class="mr-2" justify="end" no-gutters>
                <v-btn class="px-2" color="bal-red" dark @click.stop="deleteContact(index)">
                    <v-icon>delete</v-icon>
                    {{ "Delete" | t }}
                </v-btn>
            </v-row>
            <v-divider class="my-2" />
        </div>
        <v-btn class="px-2 ml-2" color="bal-red" dark style="min-width: 0;" @click.stop="addNewContact">
            <v-icon>add</v-icon>
            <span>{{ "Add new" | t }}</span>
        </v-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "@/store";

export default {
    name: "contacts-info-edit-tab",
    computed: {
        ...mapState("ExportClientStore", ["activeClient"])
    },
    methods: {
        updateContactField(value, field, index) {
            Store.commit("ExportClientStore/updateActiveClientContactProperty", {
                prop: field,
                value: value,
                index: index
            });
        },
        addNewContact() {
            Store.commit("ExportClientStore/addNewClientContact");
        },
        deleteContact(index) {
            if (confirm("Are you sure you want to delete this contact?")) {
                Store.commit("ExportClientStore/deleteClientContact", index);
            }
        }
    }
};
</script>

<style scoped>
.row-title {
    color: grey;
}
</style>
